import { render } from "./TicketForm.vue?vue&type=template&id=64b50c75"
import script from "./TicketForm.vue?vue&type=script&lang=ts"
export * from "./TicketForm.vue?vue&type=script&lang=ts"

import "./TicketForm.vue?vue&type=style&index=0&id=64b50c75&lang=scss"
script.render = render

export default script